import { Breakpoint } from "react-socks"
import { useStaticQuery, graphql } from "gatsby"
import React from "react"

import { Button } from "../inputs"
import { FeatureCTA } from "../features/styled"
import { HomeH4, YekanParagraph } from "../typography"
import { ImageContainer, TemplateContainer } from "./styled"
import { colors } from "../../utils/styleVariables"
import ImageLaptop from "./imageLaptop"
import ImageMobile from "./imageMobile"

const HomeTemplates = () => {
  const data = useStaticQuery(graphql`
    {
      yaml: contentYaml(header: { slug: { eq: "/index" } }) {
        content {
          templates {
            subtitle
            title
            ctaTitle
            ctaButton
            to
          }
        }
      }
    }
  `)
  const {
    title,
    subtitle,
    ctaTitle,
    ctaButton,
    to,
  } = data.yaml.content.templates

  return (
    <TemplateContainer direction="vertical">
      <HomeH4>{title}</HomeH4>
      <YekanParagraph>{subtitle}</YekanParagraph>
      <ImageContainer>
        <Breakpoint mobile up>
          <ImageLaptop />
        </Breakpoint>
        <Breakpoint base only>
          <ImageMobile />
        </Breakpoint>
        <FeatureCTA>
          <YekanParagraph>{ctaTitle}</YekanParagraph>
          <Button
            text={ctaButton}
            shadowColor={colors.coralShadow}
            backgroundColor={[...colors.coral, "0.3"]}
            color={colors.coral}
            name={ctaButton}
            to={to}
          />
        </FeatureCTA>
      </ImageContainer>
    </TemplateContainer>
  )
}

export default HomeTemplates
